import { Box, Text } from '@chakra-ui/layout'
import React from 'react'
// import "react-multi-carousel/lib/styles.css";
// import "react-multi-carousel/lib/styles.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { GrFormNext, GrFormPrevious } from 'react-icons/gr';
import { Img } from '@chakra-ui/image';
import Imgone from '../../assets/image/gallary1.webp'
import Imgtwo from '../../assets/image/gallary2.webp'
import Imgthree from '../../assets/image/gallary3.webp'
import Imgfour from '../../assets/image/gallary4.webp'
import Imgfive from '../../assets/image/gallary5.webp'
import Imgsix from '../../assets/image/gallary6.webp'

const HelpGallery = () => {
    var settings = {
        dots: true,
        infinite: true,
        autoplay: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        // initialSlide: 0,
        nextArrow: <GrFormNext color='red!important' />,
        prevArrow: <GrFormPrevious color='red!important' />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 1,
                    // infinite: true,
                    // dots: true,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,

                }
            }
        ]
    }
    return (
        <Box
            mx="auto"
            maxW="90vw"
            transition="0.5 ease-out"
            overflow="hidden"
        >
            <Text
                className='footer-FAQ'
                textAlign="center"
                color="#FB1923"
                textTransform="uppercase"
                fontWeight="bold"
                fontSize="3xl"
                letterSpacing="3px"
            >GALLERY</Text>
            <Box
                mx={{ base: '2', sm: '2', md: '4', lg: '20', xl: '20' }} mt={6} pb={20}>
                <Slider className='gallery_slide' {...settings}>
                    <Box minW="15rem" maxW="20rem">
                        <Img loading='lazy' alt='helpnow' src={Imgone} />
                    </Box>
                    <Box minW="15rem" maxW="20rem">
                        <Img loading='lazy' alt='helpnow' src={Imgtwo} />
                    </Box>
                    <Box minW="15rem" maxW="20rem">
                        <Img loading='lazy' alt='helpnow' src={Imgthree} />
                    </Box>
                    <Box minW="15rem" maxW="20rem">
                        <Img loading='lazy' alt='helpnow' src={Imgfour} />
                    </Box>
                    <Box minW="15rem" maxW="20rem">
                        <Img loading='lazy' alt='helpnow' src={Imgfive} />
                    </Box>
                    <Box minW="15rem" maxW="20rem">
                        <Img loading='lazy' alt='helpnow' src={Imgsix} />
                    </Box>
                </Slider>
            </Box>
        </Box>
    )
}

export default HelpGallery